import { accountConfig } from "./accountConfig";
import { userConfig } from "./userConfig";
import { quickbooksConfig } from "./quickbooksConfig";
import { reportsConfig } from "./reportsConfig";

export const configs = {
  accounts: accountConfig,
  users: userConfig,
  quickbooks: quickbooksConfig,
  reports: reportsConfig,
};
